export default __webpack_public_path__ + "static/EmilioGonzalez-c9a774e0425f54bc692c12f4a9688c76.jpg";